import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { adObjectEntity } from './index';

/**
 * ADRootCA entity - alias of ADObject
 * Represents Active Directory Root CA objects
 */
export const adRootCAEntity: QueryEntity<unknown> = {
  ...adObjectEntity,
  primaryLabel: { actual: 'ADRootCA', display: 'AD Root CA' },
  alias: 'ADObject',
};
